const classNames = {
    disabled: 'is-disabled',
    hover: 'is-hover',
    active: 'is-active',
    inActive: 'is-inactive',
    involved: 'is-involved',
    lazyLoading: 'is-loading',
    isVisible: 'is-visible',
    isCurrent: 'is-current',
    isDisplayed: 'is-displayed',
    lazyPreloader: 'js-lazy-loader',
    lazyImage: 'lazy__image',
    lazyLoaded: 'is-loaded',
    fixed: 'is-fixed',
    focused: 'is-focused',
    filled: 'is-filled',
    blurred: 'is-blurred',
    invalid: 'is-invalid',
    error: 'is-error',
    selected: 'is-selected',
    open: 'is-open',
    intlTelInput: 'js-intl-tel-input',
    intlTelInputMobile: 'iti-mobile',
    searchSelect: 'js-search-select',
    isThreeLetters: 'is-three-letters'
};

const getIcon = name => `<svg class="svg-icon"><use xlink:href="#${name}"/></svg>`;

const defaultformValidationMessages = {
    invalid         : 'Некорректное значение',
    short           : 'Значение недостаточной длины',
    long            : 'Превышена допустимая длина',
    checked         : 'Должно быть отмечено',
    empty           : 'Поле не заполнено',
    select          : 'Please select an option',
    number_min      : 'too low',
    number_max      : 'too high',
    url             : 'invalid URL',
    number          : 'not a number',
    email           : 'Некорректный e-mail',
    email_repeat    : 'emails do not match',
    date            : 'invalid date',
    time            : 'invalid time',
    password_repeat : 'Пароли не совпадают',
    no_match        : 'no match',
    complete        : 'Ввод не завершён'
};

const defaultChoicesText = {
    loadingText: 'Загрузка...',
    noResultsText: 'Результаты не найдены',
    noChoicesText: 'Отсутствуют опции для выбора',
    itemSelectText: 'Нажмите, чтобы выбрать',
};

const defaultMessages = {
    lazyError: 'Ошибка загрузки изображения'
};

const variables = {
    gsapDefaultDuration: .25,
    carouselDefaultDuration: 800,
    resizeDebounce: 100,
    inputDebounce: 200,
    throttleDebounce: 100,
    debugLogs: true,
    customEventNames: {
        resize: 'page-custom-event:resize-done',
        pageReady: 'page-custom-event:page-ready',
        selectDropdownSelected: 'page-custom-event:select-dropdown-selected',
        addClubCheckFieldVisibility: 'page-custom-event:personal-add-club-check-field-visibility',
        validatedFormSubmit: 'page-custom-event:validated-form-submitted',
        registrationUserTypeSelected: 'registration-user-type-selected',
        sortClicked: 'page-custom-event:sort-has-been-clicked',
        homeDatabaseViewChanged: 'page-custom-event:home-database-view-changed',
        personalTabChanged: 'page-custom-event:personal-tab-changed',
        personalCardsUpdated: 'page-custom-event:personal-cards-updated',
        addClubReset: 'page-custom-event:personal-add-club-reset-forms',
        addClubEdit: 'page-custom-event:personal-add-club-edit-club',
        recaptchaLoaded: 'page-custom-event:recaptcha-loaded',
        offersTabChanged: 'page-custom-event:offers-tab-changed',
        postCommentsTabChanged: 'page-custom-event:post-comments-tab-changed',
        blogTabChanged: 'tabs:blog-tab-changed',
        lazyImageLoaded: 'page-custom-event:vanilla-lazy-image-loaded',
    },
    classNames,
    formValidationMessages: jsDictionary?.formValidationMessages || defaultformValidationMessages,
    choicesOptions: {
        choices: [],
        allowHTML: true,
        ...(jsDictionary?.choicesText || defaultChoicesText),
        shouldSort: false,
        classNames: {
            containerOuter: 'select',
            containerInner: 'select__inner',
            input: 'select__input',
            inputCloned: 'select__input--cloned',
            list: 'select__list',
            listItems: 'select__list--multiple',
            listSingle: 'select__list--single',
            listDropdown: 'select__list--dropdown',
            item: 'select__item',
            itemSelectable: 'select__item--selectable',
            itemDisabled: 'select__item--disabled',
            itemOption: 'select__item--choice',
            group: 'select__group',
            groupHeading : 'select__heading',
            button: 'select__button',
            activeState: classNames.active,
            focusState: classNames.focused,
            openState: 'is-open',
            disabledState: classNames.disabled,
            highlightedState: 'is-highlighted',
            selectedState: classNames.selected,
            flippedState: 'is-flipped',
            placeholder: 'select__placeholder'
        },
        callbackOnCreateTemplates: function(template) {
            return {
                item: ({ classNames }, data) => {
                    const withIcon = Boolean(data.customProperties?.icon);
                    let icon = withIcon
                        ? getIcon(data.customProperties.icon)
                        : '';

                    return template(`
                        <div class="${classNames.item} ${
                                data.highlighted
                                    ? classNames.highlightedState
                                    : classNames.itemSelectable
                            } ${
                                data.placeholder
                                    ? classNames.placeholder
                                    : ''
                            }"
                            data-item
                            data-id="${data.id}"
                            data-value="${data.value}" ${
                                data.active
                                    ? 'aria-selected="true"'
                                    : ''
                            } ${
                                data.disabled
                                    ? 'aria-disabled="true"'
                                    : ''
                            }
                        >
                            ${
                                withIcon
                                    ? icon
                                    : ''
                            }
                            ${data.label}
                        </div>
                    `);
                },
                choice: ({ classNames }, data) => {
                    const withIcon = Boolean(data.customProperties?.icon);
                    let icon = withIcon
                        ? getIcon(data.customProperties.icon)
                        : '';

                    return template(`
                        <div
                            class="${classNames.item} ${classNames.itemChoice} ${
                                data.disabled
                                    ? classNames.itemDisabled
                                    : classNames.itemSelectable
                                }"
                            data-select-text="${this.config.itemSelectText}" data-choice ${
                                    data.disabled
                                        ? 'data-choice-disabled aria-disabled="true"'
                                        : 'data-choice-selectable'
                                }
                            data-id="${data.id}"
                            data-value="${data.value}" ${
                                data.groupId > 0 ? 'role="treeitem"' : 'role="option"'
                            }
                        >
                            ${
                                withIcon
                                    ? icon
                                    : ''
                            }
                            ${data.label}
                        </div>
                    `);
                },
            };
        },
    },
    get windowWidth() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    },
    get windowHeight() {
        return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
    },
    scrollbarWidth:	window.innerWidth - document.documentElement.clientWidth,
    breakpoints: {
        m: 375,
        sm: 576,
        md: 768,
        lg: 1024,
        xl: 1580
    },
    dom: {
        header: document.getElementById('js-header'),
        wrapper: document.getElementById('js-page-wrapper'),
        footer: document.getElementById('js-footer'),
    },
    messages: jsDictionary?.errors || defaultMessages,
    hexColors: {
        primary: '#DC0000'
    },
    mapApiKey: document
        .querySelector('meta[name="ya-api-key"]')
        .getAttribute('content'),
    get mapUrl() {
      return `https://api-maps.yandex.ru/2.1/?apikey=${this.mapApiKey}&lang=ru_RU`
    },
    selectors: {
        select: '.js-custom-select',
        lazyElement: '.js-lazy-element',
        lazyWrapper: '.js-lazy-wrapper',
        buttonContent: '.js-button-content',
        cardClub: '.js-card-club',
        cardOfferClub: '.js-card-offer-club',
        cardOfferCompany: '.js-card-offer-company',
        cardPost: '.js-card-post',
        cardReview: '.js-card-review',
        fileUpload: '.js-file-upload',
        currencyIcon: '.js-currency-field-icon',
        recaptcha: '.js-form-recaptcha',
        recaptchaInput: '.g-recaptcha-response',
    },
    keys: {
        sort: {
            orderBy: 'order',
            orderKey: 'order_key'
        }
    },
    autoCompleteMaxResults: 10,
    autoCompleteClassNamePrefix: 'autocomplete_',
    cardIdPrefix: 'club-id-',
    metaNames: {
        userRole: 'user-role',
        token: 'token',
        country: 'country',
        locale: 'locale',
        isAdmin: 'is-admin',
        cityId: 'city-id'
    },
    userRoles: {
        owner: 'owner',
        player: 'player',
        guest: 'guest'
    },
    metricsAttr: 'data-metrics-payload',
    searchTypes: {
        cities: 'cities',
        subway: 'subway',
        personalCities: 'personal-cities'
    }
};

export default variables;
